import { Flex, Text } from "@radix-ui/themes";

interface Props {
  value: number;
  periodDays?: number | null;
  size?: "1" | "2";
}

export default function DeltaBadge({ value, periodDays, size = "2" }: Props) {
  const isUp = value >= 0;
  const isFlat = Math.abs(value) < 0.01;
  const color: "gray" | "green" | "red" = isFlat ? "gray" : isUp ? "green" : "red";
  const arrow = isFlat ? "—" : isUp ? "▲" : "▼";
  const suffix = periodDays && periodDays > 0
    ? `vs prior ${periodDays} ${periodDays === 1 ? "day" : "days"}`
    : "vs prior period";
  const label = `${arrow} ${Math.abs(value).toFixed(1)}% ${suffix}`;
  return (
    <Flex align="center" gap="1" aria-label={label}>
      <Text size={size} weight="medium" color={color}>
        {arrow} {Math.abs(value).toFixed(1)}%
      </Text>
      <Text size="1" color="gray">
        {suffix}
      </Text>
    </Flex>
  );
}
